import styled from 'styled-components';
import { Grid } from '../components/grid/grid.component.js';
import { Text } from '../components/text/text.component.js';
import { marginStyles } from './components.js';
import { mapBackgroundToContentColor, mapContentToBackgroundColor } from '../utils/color-mapper.js';
import 'react';

const Backdrop = styled.div `
  align-items: ${props => props.alignItems || 'center'};
  background: ${props => props.backgroundColor &&
    props.theme.colors.background[props.backgroundColor]};
  border: ${props => props.border || `1px solid ${props.theme.colors.content.secondary}`};
  border-radius: ${props => props.borderRadius ? props.theme.borderRadii[props.borderRadius] : '4px'};
  display: flex;
  height: ${props => props.height}px;
  justify-content: ${props => props.justifyContent || 'center'};
  width: ${props => props.width}px;
  flex-direction: ${props => props.flexDirection};
  padding: ${props => props.padding || '10px'};
  margin: 4px;
  ${props => props.margin && marginStyles(props.margin)}
  opacity: ${props => props.theme.opacities[props.opacity || 'high']};
`;
const SmartBackdrop = styled(Backdrop) `
  background: ${props => props.direction === 'toContent'
    ? mapBackgroundToContentColor({
        backgroundColor: props.color,
        theme: props.theme,
    })
    : mapContentToBackgroundColor({
        contentColor: props.color,
        theme: props.theme,
    })};
  height: ${props => props.height};
`;
SmartBackdrop.defaultProps = {
    height: 300,
    width: 300,
};
Backdrop.defaultProps = {
    color: 'primary',
    flexDirection: 'column',
    height: 300,
    width: 300,
};
const StoryLabel = styled(Text).attrs(props => ({
    margin: props.margin || { bottom: '16px' },
    textStyle: props.textStyle || 'paragraph400',
})) `
  color: ${props => props.color && props.theme.colors.content[props.color]};
`;
StoryLabel.defaultProps = {
    color: 'secondary',
};
styled.div `
  display: flex;
  flex-direction: ${props => props.flexDirection};
  flex-wrap: wrap;
  align-items: ${props => props.alignItems || 'center'};
`;
styled.div `
  height: 100%;
  padding: ${props => props.padding};
`;
styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 16px;
  background: ${props => props.backgroundColor &&
    props.theme.colors.background[props.backgroundColor]};
`;
styled(Grid.Column) `
  border: 2px solid ${props => props.theme.colors.background[props.borderColor]};
`;

export { Backdrop, SmartBackdrop, StoryLabel };
